module.exports = __webpack_public_path__ + "static/media/pic-live.6c1b29a8.png";